import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpokeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"spoke"}/>
}
